import script from "./PatientRosterFieldDiscrepancy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientRosterFieldDiscrepancy.vue?vue&type=script&setup=true&lang=ts"

import "./PatientRosterFieldDiscrepancy.vue?vue&type=style&index=0&id=a9df7884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9df7884"]])

export default __exports__